import clsx from 'clsx';

import type { TConfig } from '@@/auto/interfaces';

import classes from './StandardHero.module.css';

export interface IStandardHero {
  overrideClasses?: {
    hero_text_lg?: string;
  };
  title1: string;
  title2: string;
  variant?: TConfig['signUpViewConfig']['heroVariant'];
}

const testId = {
  one: 'signUpView_heroTitle1',
  two: 'signUpView_heroTitle2',
};

export default function StandardHero({
  overrideClasses = {},
  title1,
  title2,
  variant = 'across-page',
}: IStandardHero) {
  if (variant === 'across-page') {
    return (
      <h1 className={clsx(classes.root, classes.heading_variant_lg)}>
        <span className={classes.hero_text_sm_container}>
          <span className={classes.hero_text_sm} data-testid={testId.one}>
            {title1}
          </span>
        </span>
        <span
          className={clsx(classes.hero_text_lg, overrideClasses.hero_text_lg)}
          data-testid={testId.two}
        >
          {title2}
        </span>
      </h1>
    );
  }

  if (variant === 'above-form') {
    return (
      <h1 className={clsx(classes.root, classes.heading_variant_sm)}>
        <span data-testid={testId.one}>{title1}</span>
        <span data-testid={testId.two}>{title2}</span>
      </h1>
    );
  }

  return null;
}
